import React, {useEffect, useState} from 'react';
import {Link} from "react-router-dom";
import {api} from "../api/api";
import {useLanguageStore} from "../store/languageStore";

export default function ProductsPage() {
    const [activeCategory, setActiveCategory] = useState('all');

    const [productsData, setProductsData] = useState([]);
    const [categories, setCategories] = useState([]);

    const {language} = useLanguageStore()
    const isArabic = language === 'ar'


    // Product data
    const products2 = [{
        id: 1,
        name: "Waterproofing Systems",
        description: "We provide comprehensive waterproofing solutions for pools, basements, bathrooms, balconies, and all areas exposed to water and high moisture.",
        image: "/api/placeholder/400/500",
        category: "waterproofing",
        color: "teal"
    }, {
        id: 2,
        name: "Waterproofing Systems",
        description: "We provide comprehensive waterproofing solutions for pools, basements, bathrooms, balconies, and all areas exposed to water and high moisture.",
        image: "/api/placeholder/400/500",
        category: "waterproofing",
        color: "red"
    }, {
        id: 3,
        name: "Waterproofing Systems",
        description: "We provide comprehensive waterproofing solutions for pools, basements, bathrooms, balconies, and all areas exposed to water and high moisture.",
        image: "/api/placeholder/400/500",
        category: "waterproofing",
        color: "purple"
    }, {
        id: 4,
        name: "Waterproofing Systems",
        description: "We provide comprehensive waterproofing solutions for pools, basements, bathrooms, balconies, and all areas exposed to water and high moisture.",
        image: "/api/placeholder/400/500",
        category: "waterproofing",
        color: "yellow"
    }, {
        id: 5,
        name: "Waterproofing Systems",
        description: "We provide comprehensive waterproofing solutions for pools, basements, bathrooms, balconies, and all areas exposed to water and high moisture.",
        image: "/api/placeholder/400/500",
        category: "waterproofing",
        color: "blue"
    }, {
        id: 6,
        name: "Waterproofing Systems",
        description: "We provide comprehensive waterproofing solutions for pools, basements, bathrooms, balconies, and all areas exposed to water and high moisture.",
        image: "/api/placeholder/400/500",
        category: "waterproofing",
        color: "purple"
    }, {
        id: 7,
        name: "Waterproofing Systems",
        description: "We provide comprehensive waterproofing solutions for pools, basements, bathrooms, balconies, and all areas exposed to water and high moisture.",
        image: "/api/placeholder/400/500",
        category: "waterproofing",
        color: "black"
    }, {
        id: 8,
        name: "Waterproofing Systems",
        description: "We provide comprehensive waterproofing solutions for pools, basements, bathrooms, balconies, and all areas exposed to water and high moisture.",
        image: "/api/placeholder/400/500",
        category: "waterproofing",
        color: "yellow"
    }, {
        id: 9,
        name: "Ultra-Flex Adhesive",
        description: "Advanced formula adhesive for ceramic and porcelain tiles, providing superior bonding on various surfaces including concrete and drywall.",
        image: "/api/placeholder/400/500",
        category: "adhesives",
        color: "green"
    }, {
        id: 10,
        name: "Power Bond Plus",
        description: "High-strength adhesive specially designed for large format tiles and natural stone, ensuring reliable installation on walls and floors.",
        image: "/api/placeholder/400/500",
        category: "adhesives",
        color: "blue"
    }, {
        id: 11,
        name: "Surface Primer Pro",
        description: "Professional-grade primer that ensures proper adhesion of mortars and waterproofing membranes on porous and non-porous surfaces.",
        image: "/api/placeholder/400/500",
        category: "surface-preparation",
        color: "gray"
    }, {
        id: 12,
        name: "Level Master Self-Leveling Compound",
        description: "Fast-setting self-leveling compound that creates a smooth, flat surface for tile, stone, carpet, and wood flooring installations.",
        image: "/api/placeholder/400/500",
        category: "surface-preparation",
        color: "orange"
    }, {
        id: 13,
        name: "Elastic Grout Premium",
        description: "Flexible, stain-resistant grout for tile joints up to 1/2 inch wide, perfect for areas subject to movement or temperature changes.",
        image: "/api/placeholder/400/500",
        category: "grouts",
        color: "white"
    }, {
        id: 14,
        name: "Crystal Clear Sealant",
        description: "Transparent, flexible sealant for expansion joints and perimeters in bathroom and kitchen installations, with anti-mold properties.",
        image: "/api/placeholder/400/500",
        category: "sealants",
        color: "clear"
    }];


    useEffect(() => {
        api.get('categories').then(res => {
            setCategories(res.data.results)
            console.log(res.data.results)
        }).catch(err => console.log(err))

        api.get('products').then(res => {
            setProductsData(res.data)
            console.log(res.data)
        }).catch(err => console.log(err))
    }, [])

    // Filter products by category
    const filteredProducts = activeCategory === 'all' ? productsData : productsData.filter(product => product.name_en === activeCategory);

    // Product card component
    const ProductCard = ({product}) => (<Link to={`/product/${product.id}`}>
        <div className="bg-white p-4 flex flex-col h-full shadow-md rounded-lg ">
            <div className="flex justify-center mb-4">
                <img loading="lazy"
                    src={product.image}
                    alt={product.name}
                    className="w-full  object-cover rounded-md"
                />
            </div>
            <h3 className="font-bold text-lg mb-2 line-clamp-1">{isArabic ? product.name_ar : product.name_en}</h3>
            <p className="text-gray-600 text-sm line-clamp-3">{isArabic ? product.description_ar : product.description_en}</p>
        </div>
    </Link>);

    return (<div className="" dir={isArabic ? 'rtl' : 'ltr'}>
        {/* Hero Section with "Products" Text */}
        <div className="relative w-full mb-6">
            <img loading="lazy"
                src={isArabic ? require('../assest/productSlide.png') : require('../assest/productSlide2.png')}
                alt="Jidar worker in company uniform"
                className="w-full h-full object-cover "
            />
           
        </div>

        {/* Category Filter Tabs */}
        <div className="border-b border-gray-200 mb-8">
            <div className="max-w-6xl mx-auto px-4">
                <div className="flex space-x-8 overflow-x-auto">
                    <button

                        className={`py-4 px-2 text-sm transition-colors duration-300 ${activeCategory === 'all' ? 'text-green-500 border-b-2 border-green-500' : 'text-gray-500 hover:text-gray-700'}`}
                        onClick={() => setActiveCategory('all')}
                    >
                        {isArabic ? 'الكل' : "All Products"}
                    </button>

                    {categories.map(category => (<button
                        key={category.id}
                        className={`py-4 px-2 text-sm transition-colors duration-300 ${activeCategory === category.name_en ? 'text-green-500 border-b-2 border-green-500' : 'text-gray-500 hover:text-gray-700'}`}
                        onClick={() => setActiveCategory(category.name_en)}
                    >
                        {isArabic ? category.name_ar : category.name_en}
                    </button>))}
                </div>
            </div>
        </div>

        {/*/!* Current Category Title *!/*/}
        {/*<div className="max-w-6xl mx-auto px-4 mb-8">*/}
        {/*    <h2 className="text-2xl font-bold capitalize">*/}
        {/*        {activeCategory === 'all' ? '' : categories.find(c => c.id === activeCategory)?.name}*/}
        {/*    </h2>*/}
        {/*</div>*/}

        {/*/!* Products Grid *!/*/}
        {/*<div className="max-w-6xl mx-auto px-4 pb-16">*/}
        {/*    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">*/}
        {/*        {filteredProducts.map(product => (*/}
        {/*            <ProductCard key={product.id} product={product} />*/}
        {/*        ))}*/}
        {/*    </div>*/}
        {/*</div>*/}


        {/*{*/}
        {/*    productsData.length > 0 && productsData.map(productdata => {*/}
        {/*        if(activeCategory !== 'all' && productdata.category.name_en !== activeCategory ){*/}
        {/*            return null*/}
        {/*        }*/}

        {/*       return <div>*/}
        {/*            <div className="max-w-6xl mx-auto px-4 mb-8">*/}
        {/*                <h2 className="text-2xl font-bold capitalize">*/}
        {/*                    {isArabic ? productdata.category.name_ar : productdata.category.name_en}*/}
        {/*                </h2>*/}
        {/*            </div>*/}

        {/*            <div className="max-w-6xl mx-auto px-4 pb-16">*/}
        {/*                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">*/}
        {/*                    {*/}
        {/*                        <ProductCard key={productdata.id} product={productdata}/>*/}
        {/*                    }*/}

        {/*                </div>*/}
        {/*            </div>*/}

        {/*        </div>*/}
        {/*    })*/}
        {/*}*/}
        <div className="max-w-7xl mx-auto px-4 pb-16 py-5">
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">

                {productsData.length > 0 && productsData.map(productdata => {
                    if (activeCategory !== 'all' && productdata.category.name_en !== activeCategory) {
                        return null
                    }
                    return <ProductCard key={productdata.id} product={productdata}/>
                })}
            </div>
        </div>

    </div>);
}